import { render, staticRenderFns } from "./statisticalPersonnel.vue?vue&type=template&id=30c0638c&scoped=true&"
import script from "./statisticalPersonnel.vue?vue&type=script&lang=js&"
export * from "./statisticalPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./statisticalPersonnel.vue?vue&type=style&index=0&id=30c0638c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0638c",
  null
  
)

export default component.exports